export default __webpack_public_path__ + "static/ledbelichting-970eca24e03f79c8d42e69679b7acc01.png";